import React, { Component } from "react";
import { Card, Row, Col } from "antd";
import { Fragment } from "react";
import "./ClaimsDetail.css";

export default class PaymentDetailsTable extends Component {
  render() {
    return (
      <Fragment>
        <Row className="pt-2 pb-2 services-header">
          <Col span={1} className="pt-2 pl-2">
            #
          </Col>
          <Col span={1}>
            Revenue Code
          </Col>
          <Col span={2} className="pt-2 ml-2">
            Dos From
          </Col>
          <Col span={2} className="pt-2">
            Dos To
          </Col>
          <Col span={1} className="pt-2">
            CPT
          </Col>
          {/* <Col span={2}>
            <div style={{textAlign: 'center'}}>Modifier</div>
            <Row className="px-1">
              <Col span={6}>
                A
              </Col>
              <Col span={6}>
                B
              </Col>
              <Col span={6}>
                C
              </Col>
              <Col span={6}>D</Col>
            </Row>
          </Col> */}

          <Col span={2}>
            <div style={{textAlign: 'center'}}>NDC</div>
            <Row className="px-1">
              <Col span={8}>
                Code
              </Col>
              <Col span={8} className="pl-1">
                QTY
              </Col>
              <Col span={8}>
                Meas
              </Col>
            </Row>
          </Col>
          <Col span={1} className="pr-1 claimsServiceLines">
            SVC Qual
          </Col>
          <Col span={1} className="pt-2">
            Unit
          </Col>
          <Col span={1} className="claimsServiceLines">
            Unit Count
          </Col>
          <Col span={1} className="pt-2">
            Copay
          </Col>
          <Col span={1} className="pt-2">
            Coins
          </Col>
          <Col span={2} className="pt-2">
            Total Charges
          </Col>
          <Col span={2} className="mr-1 pt-2 claimsServiceLines">
            Non Covered
          </Col>
          
          <Col span={2} className="claimsServiceLines">Adjudication Status</Col>
          <Col span={2} className="pt-2">
            Status
          </Col>
          <Col span={1} className="pt-2">
            Action
          </Col>
        </Row>
      </Fragment>
    );
  }
}
